import { SetupPage, TabPermission } from 'src/app/core';
import { EndSellerNetwork } from '../../../end-seller-network.setup';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const parent: SetupPage = EndSellerNetwork.pages.endSellerManagement;
const path = 'point-of-sale';
const title = 'PAGE.END_SELLER_NETWORK.MANAGEMENT.POS.TITLE';

const res = [
  'actions',
  'actions.viewBalanceHistory',
  'actions.updateBalance',
  'actions.editPosName',
  'actions.deleteSellers',
  'actions.setupAccount',
  'editSellerName',
];

export const EndSellerManagementPointOfSaleTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
